import { css } from "@emotion/react";
import { BORDER_RADIUS_SMALL } from '../../../common-styles/borders';

export const section__header_preloader = css({
    height: '1.5em',
    width: '10em',
    borderRadius: BORDER_RADIUS_SMALL,
});
